<script>
import MixedGridImageItem from '@phoenix/mixins/components/mixedGrid/MixedGridImageItem';
import getTheLookPanel from '@maison/mixins/getTheLookPanel';
import { showPanel } from '@phoenix/helpers/panel-helper';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: { PhxsgButton },

  mixins: [MixedGridImageItem, getTheLookPanel],

  props: {
    isSubComponent: {
      default: false,
      type: Boolean,
    },
    page: {
      default: () => ({}),
      type: Object,
      required: false,
    },
    additionalClasses: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    containerClasses() {
      return !this.hasPage && !this.hasEcomPanel ? ['card-media'] : ['media-card'];
    },

    pictureClasses() {
      return ['picture', 'media-card__media', 'picture--cover'].concat(this.additionalClasses);
    },

    hasPage() {
      return this.page && this.page.url;
    },
  },

  methods: {
    showPanel,
  },
};
</script>

<template>
  <component :is="hasPage ? 'a' : 'div'" :class="containerClasses" :href="hasPage ? page.url : null">
    <div :class="pictureClasses">
      <picture-lazy v-bind="image" img-class="lazyload--fade" />
    </div>
    <div v-if="hasEcomPanel" class="media-card__actions">
      <PhxsgButton
        variant="plain"
        color="primary"
        icon-only
        icon-id="shopping-bag"
        expand-target
        data-cy="mixed-grid-get-the-look-btn"
        @click="showPanel(ecomPanelId)"
      >
        {{ $t('Accessibility.addToBag') }}
      </PhxsgButton>
    </div>
  </component>
</template>
